import { signInWithEmailAndPassword } from 'firebase/auth';
import React, { useCallback, useContext, useState } from 'react'
import { AuthContext } from '../context/AuthContext';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

const Login = ({history}) => {

  const [err, setErr] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // const {dispatch} = useContext(AuthContext)
  const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault();
    await signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      const user = userCredential.user;
      // dispatch({type:"LOGIN", payload:user})
      navigate("/index")
    })
    .catch((err) => {
      setErr(true);
    })
  }

  return (
    <div className="login-container">
        <form onSubmit={handleLogin}>
            <h1>ZuSu</h1>
            {/* <label htmlFor="email">Email</label> */}
            <input name='email' type="email" placeholder='example@gmail.com' id="email" onChange={e => setEmail(e.target.value)} />
            {/* <label htmlFor="password">Password</label> */}
            <input name='password' type="password" placeholder='Pass@123' id="password" onChange={e => setPassword(e.target.value)} />
            {err && <span style={{color: "red"}}>Invalid Email or Password !</span>}
            <button type='submit'>LOGIN</button>
        </form>
    </div>
  )
}

export default Login